import { INFINITY, MODIFICATION_TYPE, NAME_OF_PRODUCT_TYPES } from "./sf_constants"

/**
 * @brief Convert a budget from API to the data being showed in the UI.
 * 
 * Rules:
 * if either monthly budget or monthly volume is unlimited, the monthly type is set to unlimited
 * if all entries in the campaign_budgets array are same then daily budget type is set to daily budget or daily volume
 * otherwise budget by day or volume by day is set
 * @param {Object} budgetInfo {campaign_budgets: [], monthly_budget: "", monthly_volume: ""}
 * @return Object with {
 *   monthly_limit_type: "", // always present
 *   monthly_budget_units: "", // ignore if monthly_limit_type is "Unlimited"
 *   daily_limit_type: "", // always present
 *   daily_budget_units: "", // units of the budget type (dollar for dollar type, volume for volume)
 *   budget_by_day: [] // array with 7 elements, one for each day's budget
 * }
 */
export const getCampaignBudgetUIState = (budgetInfo) => {
  let budgetAndLimit = {}
  // handle monthly (budget or volume)
  if (budgetInfo.monthly_budget) {
    if (parseInt(budgetInfo.monthly_budget) >= INFINITY) {
      budgetAndLimit.monthly_limit_type = "Unlimited"
    } else {
      budgetAndLimit.monthly_limit_type = "Monthly Budget",
        budgetAndLimit.monthly_budget_units = budgetInfo.monthly_budget.toString()
    }
  } else if (budgetInfo.monthly_volume) {
    if (parseInt(budgetInfo.monthly_volume) >= INFINITY) {
      budgetAndLimit.monthly_limit_type = "Unlimited"
    } else {
      budgetAndLimit.monthly_limit_type = "Monthly Volume",
        budgetAndLimit.monthly_budget_units = budgetInfo.monthly_volume.toString()
    }
  }

  if (!budgetInfo.campaign_budgets || budgetInfo.campaign_budgets.length != 7) {
    return budgetAndLimit
  }

  if (parseInt(budgetInfo.campaign_budgets[0].dollar_budget) >= INFINITY || parseInt(budgetInfo.campaign_budgets[0].volume_budget) >= INFINITY) {
    return { ...budgetAndLimit, daily_limit_type: 'Unlimited' }
  }

  let key = '';
  let budgetArr = [];
  // if first dollar budget is set, then all days follow dollar budget
  // if (budgetInfo.campaign_budgets[0].dollar_budget) {
  //   key = 'dollar_budget';
  //   budgetArr.push(budgetInfo.campaign_budgets[0][key])
  // } else if (budgetInfo.campaign_budgets[0].volume_budget) {
  //   key = 'volume_budget';
  //   budgetArr.push(budgetInfo.campaign_budgets[0][key])
  // }

  for (let i = 0; i < budgetInfo.campaign_budgets.length; i++) {
    if (budgetInfo.campaign_budgets[i].dollar_budget > 0) {
      key = 'dollar_budget';
      budgetArr.push(budgetInfo.campaign_budgets[i][key])
    } else if (budgetInfo.campaign_budgets[i].volume_budget > 0) {
      key = 'volume_budget';
      budgetArr.push(budgetInfo.campaign_budgets[i][key])
    }
  }

  let areAllValuesSame = true
  for (let i = 1; i < budgetInfo.campaign_budgets.length; i++) {
    if (budgetInfo.campaign_budgets[i][key] !== budgetInfo.campaign_budgets[i - 1][key]) {
      areAllValuesSame = false
    }
  }

  if (areAllValuesSame) {
    if (key === 'dollar_budget') {
      budgetAndLimit.daily_limit_type = 'Daily Budget'
    } else {
      budgetAndLimit.daily_limit_type = 'Daily Volume'
    }
    budgetAndLimit.daily_budget_units = budgetArr[0]
  } else {
    if (key === 'dollar_budget') {
      budgetAndLimit.daily_limit_type = 'Budget by Day'
      budgetAndLimit.budget_by_day = budgetArr
    } else {
      budgetAndLimit.daily_limit_type = 'Volume by Day'
      budgetAndLimit.budget_by_day = budgetArr
    }
  }

  return budgetAndLimit;
}

export const INITIAL_CAMPAIGN_BUDGET_STATE = {
  monthly_dollar_budget: INFINITY,
  monthly_budget_units: INFINITY,
  data: [
    {
      day_id: 0,
      dollar_budget: INFINITY,
      modification_type: MODIFICATION_TYPE.new,
      volume_budget: INFINITY
    },
    {
      day_id: 1,
      dollar_budget: INFINITY,
      modification_type: MODIFICATION_TYPE.new,
      volume_budget: INFINITY
    },
    {
      day_id: 2,
      dollar_budget: INFINITY,
      modification_type: MODIFICATION_TYPE.new,
      volume_budget: INFINITY
    },
    {
      day_id: 3,
      dollar_budget: INFINITY,
      modification_type: MODIFICATION_TYPE.new,
      volume_budget: INFINITY
    },
    {
      day_id: 4,
      dollar_budget: INFINITY,
      modification_type: MODIFICATION_TYPE.new,
      volume_budget: INFINITY
    },
    {
      day_id: 5,
      dollar_budget: INFINITY,
      modification_type: MODIFICATION_TYPE.new,
      volume_budget: INFINITY
    },
    {
      day_id: 6,
      dollar_budget: INFINITY,
      modification_type: MODIFICATION_TYPE.new,
      volume_budget: INFINITY
    }
  ]
}


export const getBudgetOptionsForAccount = (account) => {
  let options = []
  if (account) {


    if (account.budget_option_daily_unlimited) {
      options.push({ id: 1, label: 'Unlimited', value: 'Unlimited' })
    }
    if (account.budget_option_daily_budget) {
      options.push({ id: 2, label: 'Daily Budget', value: 'Daily Budget' })
    }
    if (account.budget_option_budget_by_day) {
      options.push({ id: 3, label: 'Budget by Day', value: 'Budget by Day' })
    }
    if (account.budget_option_daily_volume) {
      options.push({ id: 4, label: 'Daily Volume', value: 'Daily Volume' })
    }
    if (account.budget_option_volume_by_day) {
      options.push({ id: 5, label: 'Volume by Day', value: 'Volume by Day' })
    }


  }
  return options

}

export const doesAccountHaveDailyBudgetOptions = (account, productType) => {
  if (!account || !productType) return false;

  // For enterprise accounts or CLICKS product type, return true since DailyBudgetType constant always has options (>0)
  const isProductTypeLeadsOrCalls = [NAME_OF_PRODUCT_TYPES.CALLS, NAME_OF_PRODUCT_TYPES.LEADS].includes(productType);
  return !account.enterprise && isProductTypeLeadsOrCalls ? getBudgetOptionsForAccount(account)?.length > 0 : true;
}